import { IModeChooser } from "@/components/excel/schema/definiens/mode";
import {
  MultiSelector,
  SingleSelector,
} from "@/components/excel/schema/label/mode/index";

export const ProvinceMode: IModeChooser = {
  default: SingleSelector.value,
  options: [SingleSelector, MultiSelector],
};
export const CityMode: IModeChooser = {
  default: SingleSelector.value,
  options: [SingleSelector, MultiSelector],
};
export const CountyMode: IModeChooser = {
  default: SingleSelector.value,
  options: [SingleSelector, MultiSelector],
};
export const ProvinceCityMode: IModeChooser = {
  default: SingleSelector.value,
  options: [SingleSelector, MultiSelector],
};
export const CityCountyMode: IModeChooser = {
  default: SingleSelector.value,
  options: [SingleSelector, MultiSelector],
};
export const ProvinceCityCountyMode: IModeChooser = {
  default: SingleSelector.value,
  options: [SingleSelector, MultiSelector],
};
